import { Link } from "react-router-dom";
import React from "react";
import "../styles/CAFinancialServices.css";
import ca1 from "../assets/services/CA 1.jpeg";
import ca2 from "../assets/services/CA2.jpeg";

const solutions = [
  {
    title: "Accounting Services",
    description:
      "Maintain organized financial records and support everyday accounting requirements through structured processes.",
  },
  {
    title: "Tax Support",
    description:
      "Assist businesses with tax-related documentation, organization and financial compliance requirements.",
  },
  {
    title: "Bookkeeping",
    description:
      "Keep financial transactions organized and up to date with practical bookkeeping support.",
  },
  {
    title: "Financial Reporting",
    description:
      "Prepare useful financial information and reports that help businesses understand their financial position.",
  },
  {
    title: "Payroll Accounting",
    description:
      "Support salary-related accounting activities and maintain organized payroll financial records.",
  },
  {
    title: "Business Finance Support",
    description:
      "Provide financial administration and support for businesses managing everyday financial requirements.",
  },
];

const process = [
  {
    title: "Understand",
    description:
      "Understand your business structure, financial requirements and existing accounting processes.",
  },
  {
    title: "Organize",
    description:
      "Structure financial information, documents and records for easier management.",
  },
  {
    title: "Manage",
    description:
      "Support accounting, bookkeeping and financial administration activities.",
  },
  {
    title: "Review",
    description:
      "Review financial information and identify ways to improve organization and reporting.",
  },
];

function CAFinancialServices() {
  return (
    <main className="finance-page">

      <section className="finance-hero">
        <div className="finance-hero-content">
          <span className="finance-eyebrow">
            CA & TAXATION
          </span>

          <h1>
            Clear Numbers
            <span> Better Decisions</span>
          </h1>

          <p>
            Manage accounting, bookkeeping, tax and financial
            administration with organized services designed
            to support your business.
          </p>

          <a href="#finance-solutions" className="finance-primary-btn">
            Explore Financial Services
            <span>→</span>
          </a>
        </div>

        <div className="finance-hero-visual">
          <div className="finance-hero-image">
            <img
              src={ca1}
              alt="Financial planning"
            />
          </div>
        </div>
      </section>

      <section className="finance-intro">
        <div className="finance-intro-header">
          <div className="finance-intro-label">
            <span>01</span>
            <p>WHAT WE SUPPORT</p>
          </div>

          <div className="finance-intro-heading">
            <h2>
              Financial management that
              <span> keeps your business organized</span>
            </h2>

            <p>
              From accounting and bookkeeping to tax support
              and financial reporting, we help businesses manage
              important financial activities more efficiently.
            </p>
          </div>
        </div>

        <div className="finance-intro-content">
          <div className="finance-intro-main">
            <span>OUR APPROACH</span>

            <h3>
              Financial information should be
              <strong> clear, organized and useful</strong>
            </h3>

            <p>
              We focus on structured financial processes that
              make important records easier to manage and
              financial information easier to understand.
            </p>
          </div>

          <div className="finance-intro-points">
            <div className="finance-intro-point">
              <span>01</span>
              <div>
                <h4>Organized records</h4>
                <p>
                  Keep accounting information and financial
                  documents structured and accessible.
                </p>
              </div>
            </div>

            <div className="finance-intro-point">
              <span>02</span>
              <div>
                <h4>Accurate information</h4>
                <p>
                  Support better financial administration through
                  consistent and organized processes.
                </p>
              </div>
            </div>

            <div className="finance-intro-point">
              <span>03</span>
              <div>
                <h4>Useful reporting</h4>
                <p>
                  Present financial information in a way that
                  helps businesses understand their position.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="finance-solutions"
        id="finance-solutions"
      >
        <div className="finance-section-heading">
          <div>
            <span className="finance-small-label">
              FINANCIAL SERVICES
            </span>

            <h2>
              Explore our
              <span> financial solutions</span>
            </h2>
          </div>

          <p>
            Practical accounting and financial support for
            businesses managing everyday financial requirements.
          </p>
        </div>

        <div className="finance-solutions-grid">
          {solutions.map((item) => (
            <article
              className="finance-solution-card"
              key={item.title}
            >
              <div className="finance-card-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="finance-tech-section">
        <div className="finance-tech-content">
          <span className="finance-small-label">
            FINANCIAL MANAGEMENT
          </span>

          <h2>
            Turn financial data
            <span> into useful information</span>
          </h2>

          <p>
            Organized financial information helps businesses
            understand performance, manage responsibilities and
            make more informed operational decisions.
          </p>

          <div className="finance-tech-points">
            <div>
              <strong>01</strong>
              <h4>Better organization</h4>
              <p>
                Keep financial records and documents organized
                for easier management.
              </p>
            </div>

            <div>
              <strong>02</strong>
              <h4>Clear reporting</h4>
              <p>
                Present financial information in a clear and
                useful format.
              </p>
            </div>

            <div>
              <strong>03</strong>
              <h4>Business visibility</h4>
              <p>
                Understand important financial information that
                supports everyday business planning.
              </p>
            </div>
          </div>
        </div>

        <div className="finance-tech-visual">
          <div className="finance-tech-image">
            <img
              src={ca2}
              alt="Financial analytics"
            />
          </div>
        </div>
      </section>

      <section className="finance-process">
        <div className="finance-process-heading">
          <span className="finance-small-label">
            HOW WE WORK
          </span>

          <h2>
            Organized finances
            <span> Clearer business</span>
          </h2>

          <p>
            We use a structured process to understand your
            financial requirements and provide practical support.
          </p>
        </div>

        <div className="finance-process-grid">
          {process.map((item, index) => (
            <article
              className="finance-process-item"
              key={item.title}
            >
              <div className="finance-process-number">
                {String(index + 1).padStart(2, "0")}
              </div>

              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="finance-final">
        <div className="finance-final-content">
          <div className="finance-final-main">
            <div className="finance-final-label">
              <span></span>
              ORGANIZE YOUR FINANCES
            </div>

            <h2>
              Make your numbers
              <span> work for your business</span>
            </h2>

            <p>
              Tell us about your accounting or financial
              requirements. We can help you explore suitable
              support for your business.
            </p>
          </div>

          <div className="finance-final-action">
            <div className="finance-final-brand">
              <strong>TECHLYNX INNOVATIONS</strong>
              <p>Finance · Accuracy · Growth</p>
            </div>

            <Link
              to="/contact"
              className="finance-final-btn"
            >
              Start a conversation
              <span>↗</span>
            </Link>
          </div>
        </div>
      </section>

    </main>
  );
}

export default CAFinancialServices;